/**
 * @param {string} image
 * @param {import('./types').ResizerProperties} resizer
 */
function getImageUrl(image, resizer) {
  if (!image) return '';
  var width = resizer.width,
    height = resizer.height;
  if (!resizer || !width || !height) {
    console.error('@dtvgo/imageResizer.getImageUrl Error: No resizer object defined or the resizer objet does not have the width and height properties');
    return image;
  }
  try {
    return image.replace(/\/fit-in\/\d+x\d+\//, "/fit-in/".concat(width, "x").concat(height, "/"));
  } catch (error) {
    console.error('@dtvgo/imageResizer.getImageUrl Error:', error);
    return image;
  }
}
function createImageResizer() {
  return {
    getImageUrl: getImageUrl
  };
}

export { createImageResizer as default };
//# sourceMappingURL=imageResizer.js.map
